import {ApplicationError} from './errorTypesV2';

export interface ApplicationCancel {
  message: string;
}

export interface ApplicationCancelToken {
  promise: Promise<ApplicationCancel>;
  throwIfRequested(): void;
}

export type ApplicationCanceller = (message?: string) => void;

export interface ApplicationCancelTokenSource {
  cancel: ApplicationCanceller;
  token: ApplicationCancelToken;
}

export class ApplicationCancelError extends ApplicationError {}

export function buildApplicationCancelTokenSource(): ApplicationCancelTokenSource {
  let resolve: ((cancel: ApplicationCancel) => void) | null = null;
  let wasResolveCalled = false;

  const promise = new Promise<ApplicationCancel>((promiseResolve) => {
    resolve = promiseResolve;
  });

  const cancel: ApplicationCanceller = (message) => {
    if (!resolve) {
      throw new Error('Promise initialization failed');
    }

    wasResolveCalled = true;
    resolve({message: message || 'The process was cancelled.'});
  };

  const throwIfRequested = () => {
    if (wasResolveCalled) {
      throw new ApplicationCancelError();
    }
  };

  const token = {
    promise,
    throwIfRequested,
  };

  return {
    cancel,
    token,
  };
}
